"use client";

import { useEffect } from "react";
import { trackClick } from "./track";

function realTarget(e) {
  if (e.target.hasAttribute("track-click")) return e.target;
  if (e.target.parentNode.hasAttribute("track-click"))
    return e.target.parentNode;
  if (e.target.parentNode.parentNode.hasAttribute("track-click"))
    return e.target.parentNode.parentNode;
}

export const ClickTracker = (): null => {
  useEffect(() => {
    function handleClick(e) {
      const target = realTarget(e);

      if (!target) return;

      trackClick(target.getAttribute("track-click"), target.textContent);
    }

    const element = document.body;

    element?.addEventListener("click", handleClick);

    return () => {
      element?.removeEventListener("click", handleClick);
    };
  }, []);

  return null;
};
